import { initialize, LDClient, LDFlagSet } from 'launchdarkly-js-client-sdk'
import { pipe } from 'lodash/fp'

import { http } from 'vue-common/src/services/http'
import reduceFlags, { FeatureFlagModel } from '@/store/modules/feature-flags/helpers/reduce-flags'

export class LaunchDarklyService {
  private static _instance: LaunchDarklyService
  private _ldClient!: LDClient
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  private async init(): Promise<void> {
    if (this._ldClient) return
    const { data } = await http.get('/v1/env')
    const launchDarklyKey = data.LAUNCH_DARKLY_KEY
    this._ldClient = initialize(launchDarklyKey, { key: 'initial_load', anonymous: true })
    return this._ldClient.waitForInitialization()
  }

  public async identify(email: string, sub: string): Promise<FeatureFlagModel> {
    await this.init()
    const userFlags = await this._ldClient.identify({
      key: sub,
      email,
      anonymous: false
    })
    return this.getFlags(userFlags)
  }

  public static get instance(): LaunchDarklyService {
    if (!this._instance) {
      this._instance = new LaunchDarklyService()
    }
    return this._instance
  }

  public async applicationFlags(): Promise<FeatureFlagModel> {
    await this.init()
    const allFlags = this._ldClient.allFlags()
    return this.getFlags(allFlags)
  }

  private getFlags(flags: LDFlagSet): FeatureFlagModel {
    return pipe(Object.entries, reduceFlags)(flags)
  }
}
